const axios = require('axios');

let endpoint = (process.env.NODE_ENV === 'production')?'https://gabapi.lucien.ai':'http://localhost:3000';

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const session = uuid();

export default function track (type, event, payload) {
  if(process.env.NODE_ENV !== 'production') {

  }
  try {

  } catch(err) {
    console.log("Tracking error");
  }
}